export default "__VITE_ASSET__CX9ZT11N__"